import { error } from '../app/logger.js';
import { AsapPromise } from '../util/asap_promise.js';

/**
 * Used to prioritize UI calls.
 */
class UIQueue {
  createQueable(func) {
    return async (...args) => {
      this.count++;
      // Ask the user if he wants to save his changes before he leaves.
      window.addEventListener('beforeunload', this.handleBeforeUnload, false);
      try {
        await func(...args);
      } catch (e) {
        error(e);
      }
      window.removeEventListener(
        'beforeunload',
        this.handleBeforeUnload,
        false
      );
      this.count--;

      // Invoke background tasks if any.
      if (this.count == 0) {
        let backgroundTask = this.#backgroundQueue.shift();
        if (backgroundTask) {
          return this.run(backgroundTask);
        }
      }
    };
  }

  run(func) {
    return this.createQueable(func)();
  }

  runInBackground(func) {
    if (this.#count == 0) {
      return this.run(func);
    }
    let promise = new AsapPromise();
    this.#backgroundQueue.push(() =>
      Promise.resolve(func()).then(() => promise.resolve())
    );
    return promise;
  }

  handleBeforeUnload() {
    return true;
  }

  #count = 0;
  #backgroundQueue = [];
}

const uiQueue = new UIQueue();

const UIQueueable = (...args) => uiQueue.createQueable(...args);

const run = func => uiQueue.run(func);
const runInBackground = func => uiQueue.runInBackground(func);

export { UIQueueable, run, runInBackground };
